import { Typography, styled } from "@mui/material";
import { useEffect } from "react";
import PageTemplate from "../../components/template/page-template";
import { useAppDispatch } from "../../redux/store";
import { IWithClassName, IWithThemeProps } from "../../theme/default.theme";
import Preferences from "./components/user-preferences";
import { initUserPreferencesAction } from "./redux/user-preferences.action";

const Page = ({ className }: IWithClassName) => {
    const dispatch = useAppDispatch();

    useEffect(() => {
        dispatch(initUserPreferencesAction());
    }, []);

    return (
        <PageTemplate pageTitle={"RetailStat POI Data"}>
            <Typography variant="h6" className={className}>
                USER PREFERENCES
            </Typography>
            <Preferences />
        </PageTemplate>
    );
};

export default styled(Page)(({ theme }: IWithThemeProps) => ({
    color: theme?.palette.text.primary,
    fontSize: "20px",
    marginBottom: theme?.spacing(4),
    fontWeight: 600,
    textTransform: "uppercase",
}));
